var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeline-scale",style:({
    height: _vm.px(_vm.height),
  })},[_vm._l((_vm.times),function(ref){
  var at = ref.at;
  var time = ref.time;
  var minute = ref.minute;
return _c('div',{key:at,staticClass:"scale",style:(_vm.style(at, minute)),on:{"click":function($event){return _vm.onClick(at, time, minute)},"mouseover":function($event){return _vm.onHover(at, true)},"mouseleave":function($event){return _vm.onHover(at, false)}}},[_vm._t("scale",null,{"at":at,"time":time,"minute":minute})],2)}),_c('div',{staticClass:"content",style:({ height: _vm.px(_vm.height) })},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }